import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges, ViewChild,
} from '@angular/core';

import * as wjcCore from '@mescius/wijmo';
import { ConditionFilter, FilterCondition } from '@mescius/wijmo.grid.filter';
import { MarWijmoColumnDef, MarWijmoTableOptions } from '../../models/mar-wijmo-table';
import { WjFlexGridFilter } from '@mescius/wijmo.angular2.grid.filter';
import * as wjcGrid from '@mescius/wijmo.grid';

export interface CallbackEditEnding {
  binding: string;
  previousData: any;
  dataItem: any;
}

@Component({
  selector: ' mar-wijmo-table-v2',
  standalone: false,
  templateUrl: './mar-wijmo-table-v2.component.html',
  styleUrl: `./mar-wijmo-table-v2.component.scss`
})
export class MarWijmoTableV2Component implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @Output() callback = new EventEmitter();
  @Output() callbackEditEnding: EventEmitter<CallbackEditEnding> = new EventEmitter();
  @Input() items: any[] = [];
  @Input() state: any = {};
  @Input() columnsMultiselect: { key: any, value: any }[] = [];

  @Input() options: MarWijmoTableOptions = {
    tableName: 'defaultWijmoTable',
    isReadOnly: true,
    allowPinning: false,
    frozenColumns: 0,
    showSearch: true,
    showGroupPanel: false,
    autoSizeOnInit: true,
    allowSorting: 0,
    exportBaseName: 'dados',
  };

  @ViewChild('grid', { static: true }) grid!: wjcGrid.FlexGrid;


  columns: MarWijmoColumnDef[] = [];
  columnsCollection: MarWijmoColumnDef[] = [];

  constructor(
    private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['state']?.currentValue) {
      if (changes['state']?.currentValue?.columns) {
        try {
          this.columns = [...changes['state']?.currentValue?.columns];
          this.columnsCollection = [...this.columns.filter(c => c.type === 'collection')];
          this.grid.refresh();
        } catch (e) {
          console.log(e);
        }
      }
    }
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
  }

  initFilter(filter: WjFlexGridFilter) {
    this.columnsCollection.forEach(cc => {
      this.covertToSingleValuesFilter(filter, cc.binding);
    });
  }

  singleValueFilter(dataMap = null) {
    return function (value) {
      // default settings for filter (need not to be changed)
      var col = this.column;
      if (!col || !col.binding || !this.showValues || !Object.keys(this.showValues).length) {
        return true;
      }
      //
      value = value[col.binding];
      value = this.dataMap
        ? this.dataMap.getDisplayValue(value) || ''
        : col.dataMap
          ? col.dataMap.getDisplayValue(value) || ''
          : wjcCore.Globalize.format(value, col.format);

      // default setting ends here

      // apply conditions
      // split the string to create an array
      // and check if any of the value from the array is present or not
      let actualVals = value.split(',');
      for (let i = 0; i < actualVals.length; i++) {
        let val = dataMap ? dataMap.getDisplayValue(actualVals[i]) : actualVals[i];
        if (this.showValues[val] != undefined) {
          return true;
        }
      }
      return false;
    };
  }

  covertToSingleValuesFilter(filter, binding: string, dataMap = null) {
    let valFilter = filter.getColumnFilter(binding).valueFilter;
    // control sorting of values in filter dropdown listbox
    valFilter.sortValues = false;

    // override default filter apply function
    valFilter.apply = this.singleValueFilter(dataMap);

    // update the unique values of the filter dropdown, to show single names, instead of csv values
    this.updateUniqueValues(filter, binding, dataMap);
  }

  updateUniqueValues(filter, colBinding, dataMap) {
    let colFilter = filter.getColumnFilter(colBinding);
    let uniqVals = this.getUniqueValues(colFilter.valueFilter.getUniqueValues());
    if (dataMap) {
      uniqVals = uniqVals.map((val) => dataMap.getDisplayValue(val));
    }
    colFilter.valueFilter.uniqueValues = uniqVals;
  }

  // you can use this method to get unique values
  getUniqueValues(arr) {
    let set = new Set();
    arr.forEach((val) => {
      val.value.forEach((item) => {
        set.add(item.toString());
      });
    });
    return Array.from(set);
  }


  initEditor(s) {
    // s.itemFormatter = (index, content) => {
    //   return this.categories.find((t) => t.value == content).name;
    // };
    //
    // s.headerFormatter = (sender) => {
    //   return this.categories.filter((t) => sender.checkedItems.includes(t.value)).map((t) => t.name);
    // };
  }

}


// Update condition filter for MultiSelect editor column
ConditionFilter.prototype.apply = function (e) {
  var t = this._col,
    i = this._c1,
    l = this._c2,
    r = !1,
    n = !1;
  if (!t || !t._binding || !this.isActive) return !0;
  e = t._binding.getValue(e);
  var o = this.dataMap || t.dataMap;
  if (Array.isArray(e)) {
    e = e.join();
  }
  if (o) e = o.getDisplayValue(e);
  else if (wjcCore.isDate(e)) {
    r = !this._hasTimePart();
    n = !this._hasDatePart();
    var a = FilterCondition._refDateTime;
    r
      ? (e = wjcCore.DateTime.fromDateTime(e, a))
      : n && (e = wjcCore.DateTime.fromDateTime(a, e));
  } else if (wjcCore.isNumber(e)) {
    var s = wjcCore.Globalize,
      u = t.format,
      d = s.formatNumber(e, u);
    e = s.parseFloat(d, u);
  }
  var c = i.apply(e, r, n),
    p = l.apply(e, r, n);
  return i.isActive && l.isActive
    ? this._and
      ? c && p
      : c || p
    : i.isActive
      ? c
      : !l.isActive || p;
};
